import { RPCDocs } from "../../../../services/rpc.js";
import { FLAG_TIER_COLOR } from "./types.js";
import { clusterGpsFlags, formatDuration, formatGpsWindowsLabel } from "./gps-windows.js";
import { ShiftFlagBadge } from "./ShiftFlagBadge.js";
import dayjs from "dayjs";
import "react";
import { Badge, Tooltip } from "@therms/atalaya";
import { jsx, jsxs } from "react/jsx-runtime";
//#region src/modules/Scheduling/shared/shift-flags/ShiftFlagList.tsx
var Type = RPCDocs.Scheduling.StartShift.v1.Type;
function ShiftFlagList({ flags }) {
	if (!flags?.length) return null;
	const gpsFlags = flags.filter((flag) => flag.type === Type.GpsOutOfBounds);
	const nonGpsFlags = flags.filter((flag) => flag.type !== Type.GpsOutOfBounds);
	const gpsWindows = clusterGpsFlags(gpsFlags);
	return /* @__PURE__ */ jsxs("div", {
		className: "gap-x-xxs gap-y-xxs flex flex-wrap",
		children: [nonGpsFlags.map((flag, index) => /* @__PURE__ */ jsx(ShiftFlagBadge, { flag }, `${flag.type}-${flag.timestamp}-${index}`)), gpsWindows.length > 0 && /* @__PURE__ */ jsx(Tooltip, {
			tooltip: /* @__PURE__ */ jsx("div", { children: gpsWindows.map((window, index) => /* @__PURE__ */ jsx("div", { children: window.readingCount === 1 ? `${dayjs(window.start).format("h:mm a")} · 1 reading` : `${dayjs(window.start).format("h:mm a")} – ${dayjs(window.end).format("h:mm a")} · ${formatDuration(window.durationMs)}` }, `${window.start}-${index}`)) }),
			children: /* @__PURE__ */ jsx(Badge, {
				color: FLAG_TIER_COLOR.problem,
				value: formatGpsWindowsLabel(gpsWindows)
			})
		})]
	});
}
//#endregion
export { ShiftFlagList };

//# sourceMappingURL=ShiftFlagList.js.map